<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="bodymatter">
<span epub:type="pagebreak" id="p35" title="35">
<p class="icon"><span class="grey">[</span> QUICK PREP <span class="grey">]</span></p>
<h2 class="recipetitle" id="spinach_pesto_egg_bakes">Spinach-Pesto Egg Bakes</h2>
<p class="recipetime"><span class="yield_black">4 servings</span> <span class="separater">|</span> Prep Time: 15 Minutes <span class="separater">|</span> Start to Finish: 50 Minutes</p>
<p class="dot">•••</p>
<ul class="ingredient">
<li class="list"><span class="qty1">¼</span> cup pine nuts</li>
<li class="list"><span class="qty1">1</span> cup frozen cut leaf spinach (from 14-oz bag), thawed, squeezed to drain</li>
<li class="list"><span class="qty1">1</span> cup cottage cheese</li>
<li class="list"><span class="qty1">1</span> cup shredded Monterey Jack cheese (4 oz)</li>
<li class="list"><span class="qty1">¼</span> cup basil pesto</li>
<li class="list"><span class="qty1">4</span> eggs, beaten</li>
<li class="list"><span class="qty1">¼</span> cup milk</li>
<li class="list"><span class="qty1">1</span> medium tomato, chopped</li>
<li class="list"><span class="qty1">¼</span> cup shredded Parmesan cheese (1 oz)</li>
<li class="list"><span class="qty1"></span> Fresh basil leaves, if desired</li>
</ul>
<p class="recipeprocedure"><span class="stepnum">1</span> Heat oven to 375°F. Lightly spray 4 (10-oz) custard cups or ramekins with cooking spray. Place cups on cookie sheet with sides.</p>
<p class="recipeprocedure"><span class="stepnum">2</span> Sprinkle pine nuts in ungreased 8-inch skillet. Cook over medium heat 5 to 7 minutes, stirring frequently until nuts begin to brown, then stirring constantly until light brown.</p>
<p class="recipeprocedure"><span class="stepnum">3</span> In medium bowl, mix spinach, cottage cheese, Monterey Jack cheese, pesto and toasted nuts. Stir in eggs and milk until well blended. Divide spinach mixture evenly among cups.</p>
<p class="recipeprocedure"><span class="stepnum">4</span> Bake 25 to 30 minutes or until set. Cool 2 minutes before serving.</p>
<p class="recipeprocedure"><span class="stepnum">5</span> To freeze, cool completely. Wrap tightly. Freeze up to 3 months. Thaw in refrigerator overnight. Unwrap; microwave 1 egg bake on High about 1 minute or until hot. Top with tomato and Parmesan cheese; garnish with basil.</p>
<p class="recipe_info"><span class="nutr_bold">1 Serving:</span> Calories 420; Total Fat 32g (Saturated Fat 12g, Trans Fat 0g); Cholesterol 255mg; Sodium 680mg; Total Carbohydrate 8g (Dietary Fiber 2g); Protein 25g <span class="nutr_bold">Exchanges:</span> ½ Starch, ½ Vegetable, 2½ Medium-Fat Meat, ½ High-Fat Meat, 3 Fat <span class="nutr_bold">Carbohydrate Choices:</span> ½</p>
<p class="recipe_note"><span class="tips">Fresh Idea</span> Change up the cheese here—try Cheddar, Swiss or mozzarella. They are all sold shredded, making these individual breakfast bakes even easier.</p>
</span></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// p035.vue?f0872e18